/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { FormControl, TextField, Autocomplete } from '@mui/material';
import { CustomStack, CustomToggleSwitch } from 'modules/common/components';
import styles from 'modules/dashboard/components/tab-container/inner-filter/inner-filter.module.scss';
/**
 * Moving Average Window Component
 * @param {Object} props - Component props
 * @param {string} props.movingAverage - Currently selected moving average
 * @param {Array} props.movingAverageList - List of available moving averages
 * @param {function} props.handleMovingAverageChange - Handler for changing the moving average
 * @param {function} props.handleIsMovingAverageChange - Handler for enabling/disabling the moving average
 * @param {boolean} props.isMovingAverage - Boolean to check if moving average is enabled
 */
const MovingAverageWindow = ({
  movingAverage,
  movingAverageList,
  handleMovingAverageChange,
  handleIsMovingAverageChange,
  isMovingAverage,
  isDisabled,
  id = '',
}) => (
  <CustomStack cssClassName={styles.innerFilter}>
    <FormControl>
      <CustomToggleSwitch
        label="Moving Average"
        title=""
        onChange={handleIsMovingAverageChange}
        checked={isMovingAverage}
        disabled={isDisabled}
        id={id}
        className="moving-average-toggle"
      />
    </FormControl>
    <FormControl>
      <Autocomplete
        fullWidth
        value={movingAverage}
        options={movingAverageList ?? []}
        getOptionLabel={(option) => (option.label ? `${option.label} days` : '')}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterSelectedOptions
        onChange={handleMovingAverageChange}
        disableClearable
        renderInput={(params) => (
          <TextField {...params} label="Moving Average" size="small" color="primary" />
        )}
        sx={{ mt: 2 }}
        disabled={!isMovingAverage}
      />
    </FormControl>
  </CustomStack>
);
//
export default MovingAverageWindow;
